export enum PublicSecurityStatus {
  NotSent = 'NOT_SENT',
  SentError = 'SENT_ERROR',
  SentOk = 'SENT_OK',
}
